module.exports = __webpack_public_path__ + "static/overlay-header-do-05caa84888fc1a8aaa1bbb0809034eb9.png";